export default __webpack_public_path__ + "static/media/LPBGImage.970b2df9.png";